export default "__VITE_ASSET__CLloSukR__"